import { MentorFeedbackCreateInfo } from 'types';
import { Textarea } from 'flowbite-react';
import React from 'react';
import classNames from 'classnames';

interface Props {
	handleOptionSelect: (option: string) => void;
	feedbackOptions: { label: string }[];
	mentorFeedback: MentorFeedbackCreateInfo;
	setMentorFeedback: (args: MentorFeedbackCreateInfo) => void;
	isEditable: boolean;
}

const SecondStepForm = ({
	feedbackOptions,
	mentorFeedback,
	setMentorFeedback,
	handleOptionSelect,
	isEditable,
}: Props) => {
	return (
		<div className="mb-3 w-full">
			<div className="flex w-full flex-col gap-y-7">
				<div>
					<p className="font-inter text-[16px] mb-2">{'Any generic feedback for the interviewee?'} </p>
					<Textarea
						style={{
							fontFamily: "'Inter', sans-serif",
							height: '90px',
						}}
						id="interviewee"
						readOnly={!isEditable}
						disabled={!isEditable}
						name="interviewee-feedback"
						className="mentor-textarea"
						placeholder="Rajesh had a very confident attitude....."
						value={mentorFeedback.feedback || ''}
						onChange={e => {
							setMentorFeedback({
								...mentorFeedback,
								feedback: e.target.value,
							});
						}}
					/>
				</div>

				<div>
					<p className="font-inter text-[16px]">Did you face any issues during the interview?</p>
					<div className="mt-2 flex flex-wrap items-center sm:gap-1 md:gap-x-3 md:gap-y-2">
						{feedbackOptions.map((option, index) => (
							<button
								key={index}
								disabled={!isEditable}
								className={classNames(
									isEditable ? 'cursor-pointer' : 'cursor-not-allowed disabled:opacity-[0.5]',
									'rounded-[24px] px-4 py-2 text-center font-bold sm:w-1/3',
									mentorFeedback.issuesFaced.includes(option.label)
										? 'bg-[#dfc586]'
										: `bg-gray-300 ${isEditable ? 'hover:bg-gray-200' : ''}`,
								)}
								onClick={() => handleOptionSelect(option.label)}
							>
								<p className="z-50 font-inter text-[13px] sm:text-[9px]">{option.label}</p>
							</button>
						))}
					</div>
				</div>

				<div>
					<p className="font-inter text-[16px] mb-2">Tell us what issues you have faced or how we can improve</p>
					<Textarea
						disabled={!isEditable}
						style={{
							fontFamily: "'Inter', sans-serif",
							height: '90px',
						}}
						id="improvement"
						name="improvement-feedback"
						value={mentorFeedback.improvements || ''}
						readOnly={!isEditable}
						onChange={e => {
							setMentorFeedback({
								...mentorFeedback,
								improvements: e.target.value,
							});
						}}
						placeholder="It would be helpful if the live interview could support chatting with the student..."
					/>
				</div>
			</div>
		</div>
	);
};

export default SecondStepForm;
